/**
 * Checks arrays equality
 * @param a1 first array
 * @param a2 second array
 * @returns {boolean} true if arrays are equal
 */
export function arraysEqual(a1, a2) {
  if (a1 === a2) {
    return true;
  }
  if (!a1 || !a2) {
    return false;
  }
  if (a1.length !== a2.length) {
    return false;
  }
  for (let i = 0, l = a1.length; i < l; i++) {
    if (a1[i] instanceof Array && a2[i] instanceof Array) {
      if (!arraysEqual(a1[i], a2[i])) {
        return false;
      }
    } else if (a1[i] !== a2[i]) {
      return false;
    }
  }
  return true;
}

/**
 * Find intersection of 2 arrays
 * @param a first array
 * @param b second array
 * @return {any[]}
 */
export function intersect(a, b) {
  const setB = new Set(b);
  return [...new Set(a)].filter(x => setB.has(x));
}
